import React from "react";
import styled from "styled-components";
import Icons from "./Icons"; // 아이콘 (필요시 경로 확인)

const DetailWrapper = styled.div`
    max-width: 1000px;
    margin: 40px auto;
    padding: 40px;
    background: ${(props) => (props.theme === "light" ? "white" : "#1f2937")};
    color: ${(props) => (props.theme === "light" ? "#111827" : "white")};
    border-radius: 1rem;
    box-shadow: 0 10px 25px rgba(0,0,0,0.1);
    display: flex;
    gap: 60px;
    align-items: flex-start;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
        padding: 20px;
    }
`;

// ★ 3D 효과를 위한 컨테이너 (원근감 부여)
const ImageSection = styled.div`
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    perspective: 1000px; /* 3D 공간감 형성 */
    padding: 20px;
`;

// ★ 실제 3D 변형이 일어나는 이미지 스타일
const Book3DImage = styled.img`
    max-width: 100%;
    width: 280px; /* 적당한 고정 크기 추천 */
    border-radius: 2px 5px 5px 2px; /* 책등(왼쪽)은 각지게, 책배(오른쪽)는 둥글게 */

    /* 3D 회전 및 입체감 */
    transform: rotateY(-30deg);
    box-shadow:
            -15px 10px 20px rgba(0,0,0,0.3), /* 전체 그림자 */
            inset 5px 0 10px rgba(255,255,255,0.1); /* 표지 광택 */

    /* 책등(Spine) 효과 시뮬레이션 (왼쪽 두께) */
    border-left: 12px solid ${(props) => (props.theme === "light" ? "#e5e7eb" : "#4b5563")};

    transition: transform 0.4s ease, box-shadow 0.4s ease;

    /* 마우스 올리면 정면으로 살짝 돌아오는 효과 */
    &:hover {
        transform: rotateY(-10deg) scale(1.02);
        box-shadow: -10px 15px 30px rgba(0,0,0,0.4);
    }
`;

const InfoSection = styled.div`
    flex: 1.5;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 20px;
`;

const Badge = styled.span`
    background-color: ${(props) => (props.theme === "light" ? "#eff6ff" : "#1e3a8a")};
    color: ${(props) => (props.theme === "light" ? "#2563eb" : "#93c5fd")};
    padding: 0.25rem 0.75rem;
    border-radius: 999px;
    font-size: 0.85rem;
    font-weight: 700;
    width: fit-content;
    margin-bottom: 1rem;
`;

const Title = styled.h1`
    font-size: 2.5rem;
    margin-bottom: 0.5rem;
    line-height: 1.2;
    font-weight: 800;
`;

const Author = styled.p`
    font-size: 1.1rem;
    color: ${(props) => (props.theme === "light" ? "#6b7280" : "#9ca3af")};
    margin-bottom: 2rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid ${(props) => (props.theme === "light" ? "#e5e7eb" : "#374151")};
`;

const Price = styled.div`
    font-size: 2rem;
    font-weight: bold;
    color: ${(props) => (props.theme === "light" ? "#2563eb" : "#60a5fa")};
    margin-bottom: 1.5rem;
`;

const Description = styled.p`
    font-size: 1rem;
    line-height: 1.7;
    color: ${(props) => (props.theme === "light" ? "#374151" : "#d1d5db")};
    margin-bottom: 30px;
    background-color: ${(props) => (props.theme === "light" ? "#f9fafb" : "#374151")};
    padding: 20px;
    border-radius: 10px;
`;

const ButtonGroup = styled.div`
    display: flex;
    gap: 15px;
`;

const ActionButton = styled.button`
    flex: 1;
    padding: 15px;
    border: none;
    border-radius: 0.75rem;
    font-size: 1.1rem;
    font-weight: bold;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    transition: opacity 0.2s;

    &:hover { opacity: 0.9; }
`;

function BookDetail({ book, theme, onBack, onAddToCart, convertPrice }) {
    if (!book) return null;

    return (
        <DetailWrapper theme={theme}>
            <ImageSection>
                {/* 3D 스타일이 적용된 이미지 컴포넌트 사용 */}
                <Book3DImage
                    src={book.cover.startsWith("http") ? book.cover : "https://placehold.co/300x450?text=No+Image"}
                    alt={book.title}
                    theme={theme}
                />
            </ImageSection>
            <InfoSection>
                <Badge theme={theme}>{book.category || "IT/개발"}</Badge>
                <Title>{book.title}</Title>
                <Author theme={theme}>저자: {book.author}</Author>

                <Price>{convertPrice(book.price)}</Price>

                <Description theme={theme}>
                    {book.desc ? book.desc : "이 책은 상세 설명이 존재하지 않습니다."}
                </Description>

                <ButtonGroup>
                    <ActionButton
                        onClick={() => onAddToCart(book)}
                        style={{backgroundColor: "#2563eb", color: "white"}}
                    >
                        <Icons.Cart size={20}/> 장바구니 담기
                    </ActionButton>
                    <ActionButton
                        onClick={onBack}
                        style={{backgroundColor: theme === "light" ? "#e5e7eb" : "#4b5563", color: theme === "light" ? "#374151" : "white"}}
                    >
                        목록으로
                    </ActionButton>
                </ButtonGroup>
            </InfoSection>
        </DetailWrapper>
    );
}

export default BookDetail;